import React from 'react';
import Skeleton from '../../skeleton/skeleton';
// import '../../../pages/list-page/list-page.scss';

export default function ConsoleBookingLoader() {
  return (
    <div className="supplier-booking-content">
      <table className="table-loader supplier-booking auto-column-width">
        <thead>
          <tr>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="4.861vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="8.333vw" />
            </th>
            <th>
              <Skeleton skHeight="0.694vw" skWidth="4.861vw" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4].map(() => (
            <>
              <tr>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
              </tr>
              <tr>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="6.944vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
                <td>
                  <Skeleton skHeight="0.694vw" skWidth="3.472vw" />
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}
